import React, { useContext, useEffect, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link, useParams } from "react-router-dom";
import { Row, Col, Dropdown } from "react-bootstrap";
import PageLayout from "../../layouts/PageLayout";
import { Modal, Form } from "react-bootstrap";
import Select from 'react-select';
import axios from "axios";
import './UserProfilePage.css';
import { API_URL, APP_PREFIX_PATH } from "../../constant/constant";
import { formatPhoneNumber } from "../../utils/formatPhone";
import moment from "moment";

export default function AppointmentviewPage() {

    const { t } = useContext(TranslatorContext)
    const { clinic_doctor_appointment_id } = useParams();
    const [Data, setData] = useState('');
    const [ClinicId, setClinicId] = useState('');
    const [doctorData, setdoctorData] = useState([]);
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [showImagePopup, setShowImagePopup] = useState(false);

    const [appointDoctor, setappointDoctor] = useState('')
    const [Error, setError] = useState('')


    const getData = () => {
        axios.post(API_URL + '/view_appointment_details_By_Id', { clinic_doctor_appointment_id }).then((res) => {
            setData(res.data.fetchAppointment_arr[0]);
            setClinicId(res.data.fetchAppointment_arr[0].clinic_doctor_id);
            // console.log('data', res.data.fetchAppointment_arr[0].clinic_doctor_id);

        }).catch((error) => {
            console.log(error);

        })

    }

    useEffect(() => {

        if (ClinicId) {

            // console.log('asdf', ClinicId);

            axios.post(API_URL + '/get_Appoint_doctor_By_Id', { clinic_id: ClinicId }).then((res) => {
                console.log(res);

                const formattedDoctor = res.data.doctor_arr.map(doctor => ({
                    label: doctor.doctor_name,
                    value: doctor.doctor_id
                }));
                setdoctorData(formattedDoctor);
                // console.log('doctorrr', formattedDoctor);

            }).catch((error) => {
                console.log(error);

            })
        }
    }, [ClinicId])

    const handleAppointDoctor = () => {

        if (!appointDoctor.value) {
            setError('Please select doctor');
            return;
        }


        axios.post(API_URL + '/assign_doctor', { clinic_doctor_appointment_id: clinic_doctor_appointment_id, assigned_doctor_id: appointDoctor.value }).then((res) => {
            console.log('res', res)
            getData();
        }).catch((error) => {
            console.log(error);
        })
    }

    useEffect(() => {
        getData();

    }, [])
    const handleImageClick = (imageUrl) => {
        setEnlargedImage(imageUrl);
        setShowImagePopup(true);
    };
    const handleCloseImage = () => {
        setEnlargedImage(null);
        setShowImagePopup(false);
    };

    const convertTo12HourFormat = (timeString) => {
        if (!timeString) {
            return 'N/A';
        }

        const [hour, minute] = timeString.split(':');
        if (hour === undefined || minute === undefined) {
            return 'Invalid time';
        }

        const formattedHour = hour % 12 || 12;
        const ampm = hour < 12 ? 'AM' : 'PM';
        return `${formattedHour}:${minute} ${ampm}`;
    };


    return (
        <PageLayout>
            <Col xl={12}>
                <div className="mc-card">
                    <div className='mc-breadcrumb'>
                        <h3 className="mc-breadcrumb-title">{t('appointment_details')}</h3>
                        <ul className="mc-breadcrumb-list">
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/dashboard'}`} className="mc-breadcrumb-link">{t('home')}</Link></li>
                            <li className="mc-breadcrumb-item"><Link to={`${APP_PREFIX_PATH + '/manage-appointment'}`} className="mc-breadcrumb-link">{t('appointment')}</Link></li>
                            <li className="mc-breadcrumb-item">{t('appointment_list')}</li>
                        </ul>
                    </div>
                </div>
            </Col>
            <div className="mc-card p-lg-4">
                <Row>
                    {/* <Col xl={5}>
                        <h6 className="mc-divide-title mb-4">{t('user_profile')}</h6>
                        <div className="mc-user-group">
                            <div className="">
                                <div className="">

                                    <img
                                        src={Data.image ? `${Data.image}` : `image-1720095670109.png`}
                                        alt="Profile"
                                        style={{ width: '15rem', height: '15rem', borderRadius: '5%', cursor: 'pointer' }}
                                        onClick={() => handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleImageClick(Data.image ? `${Data.image}` : `image-1720095670109.png`);
                                            }
                                        }}
                                        role="button"
                                        tabIndex={0}
                                    />

                                 
                                    {showImagePopup && (
                                        <div
                                            className="enlarged-image-overlay"
                                            onClick={handleCloseImage}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Escape') {
                                                    handleCloseImage();
                                                }
                                            }}
                                            role="button"
                                            tabIndex={0}
                                        >
                                            <span
                                                className="close-button"
                                                onClick={handleCloseImage}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleCloseImage();
                                                    }
                                                }}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                &times;
                                            </span>
                                            <img src={enlargedImage} alt="Enlarged Profile" className="enlarged-image" style={{ width: '30rem', height: '30rem' }} />
                                        </div>
                                    )}
                                </div>

                            </div>
                        </div>
                    </Col> */}
                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 ms-2">{t('patient_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.user_name}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.user_email}</span>
                                        </div>

                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('mobile')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.user_mobile)}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>
                    <Col xl={9}>
                        <h6 className="mc-divide-title  mt-3 mb-0 ms-2">{t('clinic_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.clinic_name}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.clinic_email}</span>
                                        </div>

                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('mobile')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.clinic_mobile)}</span>
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>

                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 mt-3 ms-2">{t('doctor_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">
                                    <div className="row mt-2">

                                        <div className="col-lg-4">
                                            <h6>  {t('name')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.doctor_name ? Data.doctor_name : Data.assigned_doctor}</span>
                                        </div>


                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('email')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.doctor_email ? Data.doctor_email : Data.assigned_doctor_email}</span>
                                        </div>

                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('mobile')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{formatPhoneNumber(Data.doctor_mobile || Data.assigned_doctor_mobile)}</span>

                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </Col>

                    <Col xl={9}>
                        <h6 className="mc-divide-title mb-0 mt-3 ms-2">{t('appointment_details')}</h6>
                        <div className="mc-product-view-info-group">

                            <div className="col-lg-12 content">
                                <div className="mobile-view">


                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('Date')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.month_date}</span>
                                        </div>

                                    </div>
                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('Time')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{(Data.availability_time)}</span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6> {t('service')} : </h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.service_name}</span>
                                        </div>

                                    </div>


                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>   {t('document_file')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>
                                                {Data.document_file && Data.document_file !== 'null' ? (
                                                    <a style={{ color: 'blue', textDecoration: 'underline' }} href={`${Data.document_file}`} target="_blank" rel="noopener noreferrer">
                                                        view
                                                    </a>
                                                ) : (
                                                    'NA'
                                                )}
                                            </span>
                                        </div>

                                    </div>

                                    <div className=" row mt-2">
                                        <div className="col-lg-4">
                                            <h6>{t('description')} :</h6>
                                        </div>
                                        <div className="col-lg-8">
                                            <span style={{ fontWeight: '400' }}>{Data.description}</span>
                                        </div>

                                    </div>





                                </div>
                            </div>

                        </div>
                    </Col>
                    {/* <Col xl={3}>
                        <div>
                            <Form.Label>{t('appoint_doctor')}</Form.Label>

                            <Select

                                options={doctorData}
                                value={appointDoctor}
                                onChange={(e) => {
                                    setappointDoctor(e);
                                    setError('')
                                }}

                            />
                            <p style={{ color: 'red' }}>{Error}</p>
                            <button onClick={handleAppointDoctor} className="btn btn-primary mt-3">
                                Assign
                            </button>

                        </div>
                    </Col> */}


                </Row>
            </div>
        </PageLayout>
    )
}